export enum BarcodeFormats {
  A4 = "A4",
  A5 = "A5",
  A6 = "A6",
}
